import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_OrganisationUnitDetail_PageMenu_ApiEnum } from './OrganisationUnitDetailConfigApiInterface';

export enum Config_OrganisationUnitAccountGrantsDocuments_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_OrganisationUnitAccountGrantsDocuments_Modules_ApiEnum {
    'overview' = 'overview',
    'results' = 'results',
}

export enum Config_OrganisationUnitAccountGrantsDocuments_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_OrganisationUnitAccountGrantsDocuments_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_OrganisationUnitAccountGrantsDocuments_ApiInterface
    extends ConfigDataInterface<
        Config_OrganisationUnitAccountGrantsDocuments_Modules_ApiEnum,
        Config_OrganisationUnitAccountGrantsDocuments_ActionsMenu_ApiEnum,
        Config_OrganisationUnitAccountGrantsDocuments_ActionsOther_ApiEnum,
        Config_OrganisationUnitDetail_PageMenu_ApiEnum,
        Config_OrganisationUnitAccountGrantsDocuments_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
